import { CheckSuccess, ErrorCrossIcon, Typography, WarningInfo } from '@adac-mp/components';
import React from 'react';

interface IHelperTextWithIconProps {
	hasError?: boolean;
	hasWarning?: boolean;
	hasSucceeded?: boolean;
	helperText?: React.ReactNode;
	helperTextStyle?: React.CSSProperties;
}

export const HelperTextWithIcon = ({
	hasError,
	hasWarning,
	hasSucceeded,
	helperTextStyle,
	helperText,
}: IHelperTextWithIconProps) => {
	if ((hasError || hasWarning || hasSucceeded) && helperText) {
		return (
			<div
				className="flex gap-2 pl-4 pb-3 items-center"
				style={helperTextStyle}
				role={hasError ? 'alert' : 'none'}>
				{hasError && <ErrorCrossIcon className="flex-shrink-0 inline-flex items-baseline" />}
				{hasWarning && <WarningInfo className="flex-shrink-0 inline-flex items-baseline" />}
				{hasSucceeded && <CheckSuccess className="flex-shrink-0 inline-flex items-baseline" />}
				<Typography>{helperText}</Typography>
			</div>
		);
	}
	return <></>;
};
